<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <!-- <vx-card> -->
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="numberZone"
            :description="false"
            @selected="handleSelected1"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.NumberZone") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Number Zone' })"
                  size="small"
                  >{{ $t("setup.label.CreateNumberZone") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.SourceNumberPrefix") }}</vs-th>
              <vs-th>{{ $t("setup.label.DestinationNumberPrefix") }}</vs-th>
              <vs-th>{{ $t("setup.label.ImpactCategory") }}</vs-th>
              <vs-th>{{ $t("setup.label.Rank") }}</vs-th>
              <!-- <vs-th>{{ $t("Event Record Type") }}</vs-th> -->

              <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="numberZone"
                v-for="(numberZone, index) in data"
              >
                <vs-td :data="numberZone.sourceNumberPrefix">{{
                  numberZone.sourceNumberPrefix
                }}</vs-td>
                <vs-td :data="numberZone.destinationNumberPrefix">{{
                  numberZone.destinationNumberPrefix
                }}</vs-td>
                <vs-td :data="numberZone.impactCategory">{{
                  numberZone.impactCategory
                }}</vs-td>
                <vs-td :data="numberZone.rank">{{ numberZone.rank }}</vs-td>
                <!-- <vs-td :data="broadcasters.eventrecordtype">{{
                    broadcasters.eventrecordtype
                  }}</vs-td> -->

                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EyeIcon"
                      :title="$t('setup.label.View')"
                      svgClasses="w-5 h-5 stroke-current cursor text-primary"
                      @click.stop="handleSelected1(numberZone)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 text-warning stroke-current cursor orange_icon"
                      @click.stop="EditNumZone(numberZone.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                      @click.stop="
                        deleteNumberZonePopup = true;
                        delId = numberZone.id;
                      "
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteNumberZonePopup"
      :title="$t('setup.label.Number_Zone')"
      @deletePressed="deleteNumberTeam(delId)"
      @cancelPressed="deleteNumberZonePopup = false"
    >
    </delete-popup>
    <!-- </vx-card> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      deleatId: 0,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      deleteIcPopup: false,
      deleteNumberZonePopup: false,
      // provisioningRumList: [],
      // hardwareUomList: [],
      provisioningActionsList: [],
      networkElementList: [],
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      apnZone: (state) => state.zoneSetup.GetApnZone,
      operatorZone: (state) => state.zoneSetup.GetOperatorZone,
      icZone: (state) => state.zoneSetup.GetIcZone,
      numberZone: (state) => state.zoneSetup.GetNumberZone,
      products: (state) => state.zoneSetup.GetUsageRatePlan,
    }),
  },
  methods: {
    async getNumberZoneData() {
      this.loading = true;
      try {
        this.$store.dispatch("zoneSetup/setNumberZoneList", {});
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteNumberTeam(id) {
      try {
        await this.$store.dispatch("zoneSetup/deleteNumZone", id);
        this.getNumberZoneData();
        this.deleteNumberZonePopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Number Zone Deleted Successfully!",
          type: "success",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    EditNumZone(id) {
      this.$router.push({ name: "Edit Number Zone", params: { id: id } });
    },

    handleSelected1(numberZone) {
      this.$router.push({
        name: "View Number Zone",
        params: { id: numberZone.id },
      });
    },
  },
  mounted() {
    this.getNumberZoneData();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
</style>
